import {
  Avatar,
  AvatarFallback,
  AvatarImage,
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@barfacil/barfacil-ui'
import { LayoutGrid } from 'lucide-react'

import backofficeIcon from '@/assets/images/apps/backoffice.svg'
import barfacilIcon from '@/assets/images/apps/bar-facil.svg'
import pedidosIcon from '@/assets/images/apps/pedidos.svg'

type AppOptionProps = {
  data: {
    icon: string
    label: string
    link: string
    disabled: boolean
  }
}

const apps = {
  barfacil: {
    icon: barfacilIcon,
    label: 'Bar Fácil',
    link: import.meta.env.VITE_ADM_URL,
    disabled: false,
  },
  backoffice: {
    icon: backofficeIcon,
    label: 'BackOfice',
    link: '',
    disabled: true,
  },
  pedidos: {
    icon: pedidosIcon,
    label: 'Bar Fácil App',
    link: import.meta.env.VITE_PEDIDOS_URL,
    disabled: false,
  },
}

const AppOption = ({
  data: { icon, label, disabled, link },
}: AppOptionProps) => {
  function handleOnClick() {
    window.open(link, '_blank')
  }

  return (
    <button
      className="flex size-16 cursor-pointer flex-col items-center gap-1 rounded-xl p-2 text-sm outline-none transition-colors hover:bg-sky-25 hover:text-gray-900 data-[disabled=true]:pointer-events-none data-[disabled=true]:opacity-50"
      onClick={handleOnClick}
      data-disabled={disabled}
    >
      <img src={icon} alt={label} className="size-6" />
      <span className="line-clamp-2 text-[10px] font-medium leading-none text-gray-500">
        {label}
      </span>
    </button>
  )
}

const IconAvatar = () => (
  <>
    <AvatarImage src="" alt="Apps" />
    <AvatarFallback>
      <LayoutGrid className="text-gray-300" size={24} />
    </AvatarFallback>
  </>
)

function AppsMenuContent() {
  return (
    <>
      <div className="flex items-center gap-2 p-4">
        <Avatar>
          <IconAvatar />
        </Avatar>

        <div className="line-clamp-1 flex flex-col gap-px font-medium">
          <span className="text-sm">Aplicativos</span>
          <span className="text-xs text-gray-300">{apps.backoffice.label}</span>
        </div>
      </div>

      <div className="border border-gray-100" />

      <div className="grid grid-cols-3 gap-2 p-2">
        {Object.values(apps).map((data) => (
          <AppOption key={data.label} data={data} />
        ))}
      </div>
    </>
  )
}

function AppsMenu() {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          className="py-6 hover:bg-gray-100/25 max-sm:px-2"
          variant="ghost"
        >
          <Avatar className="size-9 cursor-pointer">
            <IconAvatar />
          </Avatar>
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        className="w-60 p-0 pb-2"
        align="end"
        side="bottom"
        sideOffset={12}
      >
        <AppsMenuContent />
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export { AppsMenu }
